




























































import { chipClasses } from '@/utils/chipClasses.constant'
import { Iterable, Params } from '@/utils/interfaces'
import Vue from 'vue'
export default Vue.extend({
  props: {
    getter: Function,
    hideCanceled: Boolean,
  },
  data() {
    return {
      data: {} as Iterable,
      selectedCurrency: 'USD',
    }
  },
  computed: {
    sheets(): object {
      const totals = [
        {
          label: 'total_draft',
          field: 'total_draft',
          format: false,
          color: chipClasses.Draft.color,
          icon: chipClasses.Draft.icon,
        },
        {
          label: 'total_requested',
          field: 'total_requested',
          format: false,
          color: chipClasses.Requested.color,
          icon: chipClasses.Requested.icon,
        },
        {
          label: 'total_assigned',
          field: 'total_assigned',
          format: false,
          color: chipClasses.Assigned.color,
          icon: chipClasses.Assigned.icon,
        },
        {
          label: 'total_distributing',
          field: 'total_distributing',
          format: false,
          color: chipClasses.Distributing.color,
          icon: chipClasses.Distributing.icon,
        },
        {
          label: 'total_delivered',
          field: 'total_delivered',
          format: false,
          color: chipClasses.Delivered.color,
          icon: chipClasses.Delivered.icon,
        },
        {
          label: 'total_canceled',
          field: 'total_canceled',
          format: false,
          color: chipClasses.Canceled.color,
          icon: chipClasses.Canceled.icon,
        },
        {
          label: 'remittance.total',
          field: 'total',
          format: false,
          color: 'secondary',
          icon: 'mdi-counter',
        },
      ]
      if (this.hideCanceled) {
        const index = totals.findIndex(
          total => total.label === 'total_canceled',
        )
        totals.splice(index, 1)
      }
      const money = [
        {
          label: 'earnings',
          field: 'earning',
          format: true,
          color: 'primary',
          icon: 'mdi-cash-100',
        },
        {
          label: 'total_cost',
          field: 'total_cost',
          format: true,
          color: 'secondary',
          icon: 'mdi-cash-usd',
        },
        {
          label: 'total_price',
          field: 'total_price',
          format: true,
          color: 'accent',
          icon: 'mdi-store',
        },
        {
          label: 'total_amount',
          field: 'total_amount',
          format: true,
          color: 'primary',
          icon: 'mdi-currency-usd',
        },
      ]
      return {
        totals: totals.map(item => ({
          ...item,
          value: this.data[item.field],
        })),
        money: money.map(item => ({
          ...item,
          value: this.data[this.selectedCurrency]
            ? this.data[this.selectedCurrency][item.field]
            : 0,
        })),
      }
    },
  },
  methods: {
    async newFilter(params?: Params) {
      const response = await this.getter(params)
      this.data = response.data
    },
  },
  async mounted() {
    const response = await this.getter()
    this.data = response.data
  },
})
